import { Injectable, signal } from '@angular/core';

export interface InstructorPlatformConfig {
  id?: number;
  instructorId?: number;
  name?: string;
  logoUrl?: string;
  primaryColor?: string;
  secondaryColor?: string;
  domain?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PlatformThemeService {
  // Default Ashal branding
  readonly DEFAULT_PRIMARY = '#63518C';
  readonly DEFAULT_SECONDARY = '#F7D671';
  readonly DEFAULT_LOGO = '/assets/logo.svg';

  readonly TEMPORARY_INSTRUCTOR_ID = 43;

  readonly currentConfig = signal<InstructorPlatformConfig | null>(null);
  readonly currentLogo = signal<string>(this.DEFAULT_LOGO);

  constructor() {
    this.applyDefaultTheme();
  }

  applyPlatformTheme(): void {
    this.applyDefaultTheme();
  }

  applyDefaultTheme(): void {
    this.setCssVariables(this.DEFAULT_PRIMARY, this.DEFAULT_SECONDARY);
    this.currentLogo.set(this.DEFAULT_LOGO);
  }

  private setCssVariables(primary: string, secondary: string): void {
    if (typeof document === 'undefined') return;
    const root = document.documentElement;
    root.style.setProperty('--main-color', primary);
    root.style.setProperty('--second-color', secondary);
    root.style.setProperty('--color-accent-yellow', secondary);
    root.style.setProperty('--violet-500', primary);
  }

  resolveLogoUrl(rawLogoUrl?: string | null): string {
    if (!rawLogoUrl || typeof rawLogoUrl !== 'string' || !rawLogoUrl.trim()) {
      return this.DEFAULT_LOGO;
    }
    const trimmed = rawLogoUrl.trim();
    if (
      trimmed.startsWith('http://') ||
      trimmed.startsWith('https://') ||
      trimmed.startsWith('data:') ||
      trimmed.startsWith('/assets/')
    ) {
      return trimmed;
    }
    return this.DEFAULT_LOGO;
  }

  onLogoError(event: Event): void {
    const img = event.target as HTMLImageElement | null;
    if (img && img.src !== this.DEFAULT_LOGO) {
      img.src = this.DEFAULT_LOGO;
    }
  }
}
